<template>
  <div
    v-tooltip.right="{ html: true, content }"
    class="mr-2"
    data-entity-type="flight-alert-icon">
    <icon-airplane />
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';

  import { IconAirplane } from '@/common/icons/monochrome';
  import i18n from '@/vueI18n';

  interface IProps {
    name: string;
  }

  const props = defineProps<IProps>();

  const content = computed(() => i18n.global.t('messages.partOfAFlight', [props.name]));
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  svg {
    fill: var(--secondaryColor);
    stroke: var(--secondaryColor);
  }
</style>
